import { render, staticRenderFns } from "./AddTemplateCourses.vue?vue&type=template&id=49e328ce&scoped=true"
import script from "./AddTemplateCourses.vue?vue&type=script&lang=ts"
export * from "./AddTemplateCourses.vue?vue&type=script&lang=ts"
import style0 from "./AddTemplateCourses.vue?vue&type=style&index=0&id=49e328ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e328ce",
  null
  
)

export default component.exports